module.exports = __webpack_public_path__ + "static/media/7-ball.4516bd9a.png";